import { Observable } from 'rxjs';
import { RunStatus, SlackAppDetails } from './slack-tab/slack-tab.interface';

export interface ShareDialogData {
  reportShared: boolean;
  reportRunStatus: RunStatus;
  externalSharingTooltip: string;
  externalSharingDisabled: boolean;
  schedulingEnabled: boolean;
  internalLiveReportLink: string;
  internalStaticReportLink: string;
  externalLiveReportLink: string;
  externalStaticReportLink: string;
  ownerUsername: string;
  ownerMembershipType: string;
  emailFormModel: {
    message: string;
    options: string[];
  };
  slackAppDetails$: Observable<SlackAppDetails>;
  validEmailDomains: string[];
}

export enum Tab {
  Link = 'Link',
  Email = 'Email',
  Slack = 'Slack',
}
